import { render, staticRenderFns } from "./IndexClients.vue?vue&type=template&id=e6eaa442&scoped=true"
import script from "./IndexClients.vue?vue&type=script&lang=js"
export * from "./IndexClients.vue?vue&type=script&lang=js"
import style0 from "./IndexClients.vue?vue&type=style&index=0&id=e6eaa442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6eaa442",
  null
  
)

export default component.exports